<template>
    <UiCard :tag="tag"
            :small="small"
            class="sim-floating-card--image"
            :class="{
                'sim-floating-card--sm': small,
            }"
            :floating="floating"
            :hover="hover"
            :skeleton="skeleton"
    >
        <div class="sim-floating-card__img-el">
            <slot name="image">
                <CoreImg
                    class="size-full object-contain"
                    :src="src"
                    alt=""
                    :width="72"
                    densities="x1 x2"
                    loading="lazy"
                />
            </slot>
        </div>
        <slot />
    </UiCard>
</template>

<script lang="ts" setup>
import type { BaseUiSkeletonColors } from '../../base/BaseUiSkeleton.vue'

const {
    tag = 'div',
    small,
    src,
    floating,
    hover,
    skeleton,
} = defineProps<{
    tag?: 'div' | 'li'
    small?: boolean
    src: string | null,
    floating?: boolean
    hover?: boolean
    skeleton?: boolean | BaseUiSkeletonColors
}>()

</script>

<style lang="scss" scoped>

.sim-floating-card--image {
    display: flex;
    gap: 1.5rem;
    align-items: center;
}

.sim-floating-card--sm {
    gap: 1rem;
}

.sim-floating-card__img-el {
    $size: 3.5rem;
    flex-shrink: 0;
    width: $size;
    height: $size;
}

.sim-floating-card--sm .sim-floating-card__img-el {
    $size: 2.25rem;
    width: $size;
    height: $size;
}

</style>
